import { useIsLDClientReady } from './useIsLDClientReady';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useEffect, useState } from 'react';

export function useLDLocalStorageOverride(): {
  localStorageValues: Record<string, string | boolean>;
  isLocalStorageValuesSet: boolean;
} {
  const flags = useFlags();
  const flagKeys = Object.keys(flags);
  const isClientReady = useIsLDClientReady();
  const [localStorageValues, setLocalStorageValues] = useState<
    Record<string, string | boolean>
  >({});
  const [isLocalStorageValuesSet, setIsLocalStorageValuesSet] = useState(false);

  useEffect(() => {
    if (isClientReady) {
      const updatedValues: Record<string, string | boolean> = {};
      flagKeys.forEach((flag) => {
        const localStorageValue = localStorage.getItem(flag);
        if (localStorageValue !== null) {
          // Cast "true" and "false" strings to boolean
          updatedValues[flag] = ['true', 'false'].includes(
            localStorageValue.toLowerCase(),
          )
            ? localStorageValue.toLowerCase() === 'true'
            : localStorageValue;
        }
      });
      setLocalStorageValues(updatedValues);
      setIsLocalStorageValuesSet(true);
    }
    // Local storage values are set once when the component mounts and when the client is ready.
    // They are not dependent on the component's state or props,
    // so we can safely ignore the exhaustive-deps rule here.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isClientReady]);

  return {
    localStorageValues,
    isLocalStorageValuesSet,
  };
}
